import { loginHistoryKey } from 'common/const/login-history-key';
import _ from 'lodash';
export function saveLoginHistory(newUserLoginHistory) {
    var userLoginHistoryStr = localStorage.getItem(loginHistoryKey);
    var userLoginHistory = userLoginHistoryStr ? JSON.parse(userLoginHistoryStr) : [];
    var isExistingIndex = !!(userLoginHistory === null || userLoginHistory === void 0 ? void 0 : userLoginHistory.length)
        ? _.findIndex(userLoginHistory, function (userLoginHistoryItem) {
            return userLoginHistoryItem.userId === newUserLoginHistory.userId &&
                userLoginHistoryItem.loginType === newUserLoginHistory.loginType &&
                userLoginHistoryItem.loginInfo === newUserLoginHistory.loginInfo;
        })
        : -1;
    if (isExistingIndex !== -1) {
        userLoginHistory[isExistingIndex].lastActiveDate = new Date();
    }
    else {
        userLoginHistory.push(newUserLoginHistory);
    }
    localStorage.setItem(loginHistoryKey, JSON.stringify(userLoginHistory));
}
export function clearLoginHistory(userLoginHistoryToRemove) {
    var userLoginHistoryStr = localStorage.getItem(loginHistoryKey);
    var userLoginHistory = userLoginHistoryStr ? JSON.parse(userLoginHistoryStr) : [];
    if (!(userLoginHistory === null || userLoginHistory === void 0 ? void 0 : userLoginHistory.length))
        return [];
    if (userLoginHistoryToRemove) {
        _.remove(userLoginHistory, function (userLoginHistoryItem) {
            return userLoginHistoryItem.userId === userLoginHistoryToRemove.userId &&
                userLoginHistoryItem.loginType === userLoginHistoryToRemove.loginType &&
                userLoginHistoryItem.loginInfo === userLoginHistoryToRemove.loginInfo;
        });
        localStorage.setItem(loginHistoryKey, JSON.stringify(userLoginHistory));
    }
    else {
        localStorage.setItem(loginHistoryKey, JSON.stringify([]));
    }
    return userLoginHistory;
}
export function getLoginHistoryByUserId(userId) {
    var userLoginHistoryStr = localStorage.getItem(loginHistoryKey);
    var userLoginHistory = userLoginHistoryStr ? JSON.parse(userLoginHistoryStr) : [];
    if (!(userLoginHistory === null || userLoginHistory === void 0 ? void 0 : userLoginHistory.length))
        return null;
    return userLoginHistory.filter(function (o) { return o.userId === userId; }) || null;
}
